import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from 'react-router';
import MapPage from './MapPage';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

class App extends Component {
  render() {
    return (
      <ConnectedRouter history={this.props.history}>
        <div>
          <Switch>
            <Route exact path="/gps" component={MapPage}/>
          </Switch>
        </div>
      </ConnectedRouter>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
